import PageHeader from "../../../components/UI/Headers/PageHeader/PageHeader";
import Icons from "../../../resources/icons/Icons";
import Strings from "../../../resources/Strings";
//import classes from "./Activity.module.css";

const Activity = () => {
  return <div>
    <PageHeader
            icon={Icons.ACTIVITY}
            pageTitle={Strings.TITLES.ACTICITY}
          />
  </div>
};

export default Activity;
